/**
 * HTTP Status Codes
 * @enum {number}
 */
export enum HttpStatusCode {
  OK = 200, // Successful request
  CREATED = 201, // Resource created successfully
  NO_CONTENT = 204, // Request processed successfully but no content returned
  BAD_REQUEST = 400, // Client sent an invalid request
  UNAUTHORIZED = 401, // Authentication required or failed
  FORBIDDEN = 403, // Client does not have permission for the requested resource
  NOT_FOUND = 404, // Resource not found
  METHOD_NOT_ALLOWED = 405, // Request method not allowed for the resource
  UNSUPPORTED_MEDIA_TYPE = 415, // Unsupported media type in request
  INTERNAL_SERVER_ERROR = 500, // Server encountered an unexpected condition
  SERVICE_UNAVAILABLE = 503, // Server is currently unable to handle the request
}

// Export default for easier imports
export default HttpStatusCode
